// Utilitaires pour la gestion des URLs propres

// Créer un slug à partir d'un texte
export const createSlug = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove accents
    .replace(/[^a-z0-9\s-]/g, '') // remove special chars
    .replace(/\s+/g, '-') // spaces to dashes
    .replace(/-+/g, '-') // collapse dashes
    .trim();
};

// Mapping des catégories vers leurs slugs
export const categoryToSlug = {
  'Effets sonores': 'effets-sonores',
  'Nature': 'nature',
  'Ambiance': 'ambiance',
  'Interface': 'interface'
};

// Mapping inverse (slug vers catégorie)
export const slugToCategory = Object.fromEntries(
  Object.entries(categoryToSlug).map(([cat, slug]) => [slug, cat])
);

// Mapping des sous-catégories vers leurs slugs
export const subcategoryToSlug = {
  // Effets sonores
  'swoosh': 'swoosh',
  'explosion': 'explosion',
  'impact': 'impact',
  'cartoon': 'cartoon',
  'notification': 'notification',
  'marche': 'marche',
  'objet': 'objet',
  'transition': 'transition',
  'science fiction': 'science-fiction',
  'magique': 'magique',
  'metal': 'metal',
  'bois': 'bois',
  
  // Nature
  'montagne': 'montagne',
  'océan': 'ocean',
  'feu': 'feu',
  'riviere': 'riviere',
  'desert': 'desert',
  'pluie': 'pluie',
  'grotte': 'grotte',
  'orage': 'orage',
  'animaux': 'animaux',
  'oiseaux': 'oiseaux',
  'feuillage': 'feuillage',
  'vent': 'vent',
  
  // Ambiance
  'ville': 'ville',
  'cafe': 'cafe',
  'rue': 'rue',
  'bar': 'bar',
  'bus': 'bus',
  'metro': 'metro',
  'bureau': 'bureau',
  'halloween': 'halloween',
  'espace': 'espace',
  'nuit': 'nuit',
  'manifestation': 'manifestation',
  'foule': 'foule'
};

// Mapping inverse (slug vers sous-catégorie)
export const slugToSubcategory = Object.fromEntries(
  Object.entries(subcategoryToSlug).map(([subcat, slug]) => [slug, subcat])
);

// Générer une URL de catégorie
export const getCategoryUrl = (category, subcategory = null) => {
  const categorySlug = categoryToSlug[category];
  if (!categorySlug) return '/';
  
  if (subcategory) {
    const subcategorySlug = subcategoryToSlug[subcategory];
    if (subcategorySlug) {
      return `/category/${categorySlug}/${subcategorySlug}`;
    }
  }
  
  return `/category/${categorySlug}`;
};

// Générer une URL de son
export const getSoundUrl = (sound) => {
  const slug = sound.slug || createSlug(sound.title);
  return `/sons/${slug}`;
};

// Parser une URL de catégorie pour extraire catégorie et sous-catégorie
export const parseCategoryUrl = (categorySlug, subcategorySlug = null) => {
  const category = slugToCategory[categorySlug];
  const subcategory = subcategorySlug ? slugToSubcategory[subcategorySlug] : null;
  
  return { category, subcategory };
};

// Générer l'URL canonique pour une page
export const getCanonicalUrl = (path) => {
  const baseUrl = 'https://sound-nest.vercel.app';
  return `${baseUrl}${path}`;
};
